import React from 'react'

import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'

import TextField from '@mui/material/TextField';

import {
  useNavigate
} from "react-router-dom";

export default function Register() {

  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [dob, setDob] = React.useState('')
  const [role, setRole] = React.useState('')
  const [mob, setMob] = React.useState('')
  const [dep, setDep] = React.useState('')
  
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [conPassword, setConPassword] = React.useState('')

  const [posted, setPosted] = React.useState('')
  const navigate = useNavigate('')

  const handleFirstName = (event) => {
    setFirstName(event.target.value);
  }

  const handleLastName = (event) => {
    setLastName(event.target.value);
  }

  const handleDob = (event) => {
    setDob(event.target.value);
  }

  const handleRole = (event) => {
    setRole(event.target.value);
  }

  const handleDep = (event) => {
    setDep(event.target.value);
  }

  const handleMob = (event) => {
    setMob(event.target.value);
  }

  const handleEmail = (event) => {
    setEmail(event.target.value);
    console.log("email: "+email)
  }

  const handlePassword = (event) => {
    setPassword(event.target.value);
    console.log("password: " + password)
  }

  const handleConPassword = (event) => {
    setConPassword(event.target.value);
    console.log("confirm password: " + conPassword)
  }

  const register = async () => {
    let register_details = {
      reg_first: `${firstName}`,
      reg_last: `${lastName}`,
      //reg_dob: `${dob}`,
      reg_role: `${role}`,
      //reg_dep: `${dep}`,
      reg_mob: `${mob}`,
      reg_email: `${email}`,
      reg_password: `${password}`
    }

    // https://ic360portalbackend.azurewebsites.net
    await fetch('https://ic360portalbackend.azurewebsites.net/api/auth/register', {
      method: 'POST',
      headers: {
        'Content-type': 'application/JSON',
      },
      body: JSON.stringify({
        register_details
      })
    })    
    .then(response => response.json())
    .then (data => {
      setPosted(data)
      console.log(data)
    })

    // Error Handling
    if (posted === "Same email used") {
      alert("Email already in use. Please enter a new email")
    }
    
  }

  const handleRegister = () => {
    if (password !== conPassword) {
      alert("Passwords do not match")
    }

    else {
      register()
    }
  }

  const gotoLoginPage = () => {
    navigate('/login')
  }
  return (   
    <>
      <Navbar/>
      <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="user-access-wrapper">
        <div className="login-box">
          <div className="page-title">Dev Sign up</div>
          <div className="device-search-wrapper">
            <TextField
              label="First Name"
              variant="standard"
              color='error'
              value = {firstName}
              onChange={handleFirstName}
            />
          </div>
          <div className="device-search-wrapper">
            <TextField
              id="standard-search"
              label="Last Name"
              variant="standard"
              color='error'
              value = {lastName}
              onChange={handleLastName}
            />
          </div>
          {/* <div className="device-search-wrapper">
            <TextField
              label="DOB (yyyy-mm-dd)"
              variant="standard"
              color='error'
              value = {dob}
              onChange={handleDob}
            />
          </div> */}
          <div className="device-search-wrapper">
            <TextField
              label="Role"
              variant="standard"
              color='error'
              value = {role}
              onChange={handleRole}
            />
          </div>
          {/* <div className="device-search-wrapper">
            <TextField
              label="Department"
              variant="standard"
              color='error'
              value = {dep}
              onChange={handleDep}
            />
          </div> */}
          <div className="device-search-wrapper">
            <TextField
              label="Mobile Number"
              variant="standard"
              color='error'
              value = {mob}
              onChange={handleMob}
            />
          </div>
          <div className="device-search-wrapper">
            <TextField
              label="Email"
              variant="standard"
              color='error'
              value = {email}
              onChange={handleEmail}
            />
          </div>
          <div className="device-search-wrapper">
            <TextField
              label="Password"
              variant="standard"
              color='error'
              value = {password}
              onChange={handlePassword}
              type='password'
            />
          </div>
          <div className="device-search-wrapper">
          <TextField
            label="Confirm Password"
            variant="standard"
            color='error'
            value = {conPassword}
            onChange={handleConPassword}
            type='password'
          />
        </div>
  
          <div className="device-buttons-bar device-filter-bar">
            <div className="login-button" onClick={handleRegister}>Register</div>
          </div>
  
        </div>
  
      </div>
      
      <Footer/>
      </div> 
    </>)
}
